import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';
import { SeasonOverviewCommonWidgetFilters, SeasonSummaryData } from '../types';
import { useSelector } from 'react-redux';
import { selectToken } from 'store/auth/selectors';

interface UseSeasonSummaryQueryProps extends SeasonOverviewCommonWidgetFilters {
  viewType: string;
}

const useSeasonSummaryQuery = (params: UseSeasonSummaryQueryProps) => {
  const token = useSelector(selectToken);
  const query = useQuery({
    queryKey: ['god-view-seasonSummary', { token, params }],
    queryFn: async ({ signal }) =>
      API.get('/god-view-dashboard/season-summary', {
        signal,
        params,
      }),
    select: (res) => res?.data as SeasonSummaryData,
    enabled: !!params?.country && !!params?.seasonTypeId && !!params?.viewType,
    staleTime: 1000 * 60 * 60, // here caching can be for 1hr or more as the data only refreshed once a day in the backend,
  });

  return query;
};

export default useSeasonSummaryQuery;
